// src/lib/eventTypes.js
// ONE definition of event types, shared by Employee Scheduling and the
// Contacts outreach timeline so badges always match everywhere.
import React from 'react';

export const EVENT_TYPES = {
  jobsite: { label: 'Jobsite', chip: 'bg-emerald-500/20 text-emerald-300 ring-emerald-500/40' },
  service: { label: 'Service Call', chip: 'bg-amber-500/20 text-amber-300 ring-amber-500/40' },
  jobwalk: { label: 'Job Walk/Estimate', chip: 'bg-sky-500/20 text-sky-300 ring-sky-500/40' },
  followup: { label: 'Follow-up Call/Text', chip: 'bg-violet-500/20 text-violet-300 ring-violet-500/40' },
};

export const EventBadge = ({ type, className = '' }) => EVENT_TYPES[type] ? (
  <span className={`inline-block text-[9px] font-bold uppercase px-1.5 py-0.5 rounded-full ring-1 ${EVENT_TYPES[type].chip} ${className}`}>
    {EVENT_TYPES[type].label}
  </span>
) : null;

// Tap-to-pick chip row (tap the active one again to clear).
export const EventTypePicker = ({ value, onChange, className = '' }) => (
  <div className={`flex flex-wrap gap-1.5 ${className}`}>
    {Object.entries(EVENT_TYPES).map(([key, et]) => {
      const on = value === key;
      return (
        <button
          key={key}
          type="button"
          onClick={() => onChange(on ? '' : key)}
          className={`text-[10px] font-bold uppercase px-2.5 py-1 rounded-full ring-1 transition-colors ${
            on ? et.chip : 'bg-gray-800/70 text-zinc-500 ring-gray-700 hover:text-zinc-300'
          }`}
        >
          {et.label}
        </button>
      );
    })}
  </div>
);
